import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { getUserById } from '../services/userService';
import ArtistAlerts from './ArtistAlerts';
import ListenerAlerts from './ListenerAlerts';

const Alerts = ({ embedded = false }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!auth.currentUser) {
                if (!embedded) navigate('/login');
                setLoading(false);
                return;
            }
            try {
                const userData = await getUserById(auth.currentUser.uid);
                if (!cancelled) {
                    setUser(userData);
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error fetching user:', err);
                if (!cancelled) {
                    setLoading(false);
                    if (!embedded) navigate('/');
                }
            }
        })();
        return () => { cancelled = true; };
    }, [navigate, embedded]);

    if (loading) {
        return (
            <div className={`${embedded ? 'h-full' : 'min-h-screen'} bg-[#0e0e0e] text-white flex items-center justify-center`}>
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <div className={`${embedded ? 'h-full' : 'min-h-screen'} bg-[#0e0e0e] text-white flex items-center justify-center`}>
                <p className="text-white/70">Could not load alerts.</p>
            </div>
        );
    }

    if (user.role === 'artist') {
        return <ArtistAlerts embedded={embedded} />;
    }
    if (user.role === 'listener') {
        return <ListenerAlerts embedded={embedded} />;
    }

    return (
        <div className={`${embedded ? 'h-full' : 'min-h-screen'} bg-[#0e0e0e] text-white flex items-center justify-center`}>
            <p className="text-white/70">Complete your profile to see alerts.</p>
        </div>
    );
};

export default Alerts;
